import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useCallback, useEffect, useState } from "react";
import { useApolloClient } from "@apollo/client";
import { useHistory } from "react-router";

/**
 * Returns props necessary to render a ForgotPassword form.
 *
 * @function
 *
 * @param {Function} props.onCancel - callback function to call when user clicks the cancel button
 * @param {RequestPasswordEmailMutations} props.mutations - GraphQL mutations for the forgot password form.
 *
 * @returns {ForgotPasswordProps}
 *
 * @example <caption>Importing into your project</caption>
 * import { useForgotPassword } from '@magento/peregrine/lib/talons/ForgotPassword/useForgotPassword.js';
 */
export var useForgotPassword = props => {
  var {
    onCancel,
    mutations
  } = props;
  var [hasCompleted, setCompleted] = useState(false);
  var [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
  var [isResettingPassword, setIsResettingPassword] = useState(false);
  var [requestResetEmailError, setRequestResetEmailError] = useState(null);
  var client = useApolloClient();
  var history = useHistory();
  var resetValues = () => {
    setCompleted(false);
    setForgotPasswordEmail("");
    setIsResettingPassword(false);
    setRequestResetEmailError(null);
  };
  useEffect(() => {
    resetValues();
  }, []);
  var handleFormSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (_ref) {
      var {
        email
      } = _ref;
      try {
        setForgotPasswordEmail("");
        setIsResettingPassword(true);
        setRequestResetEmailError(null);
        // await requestResetEmail({ variables: { email } });
        var result = yield client.mutate({
          mutation: mutations.requestPasswordResetEmailMutation,
          variables: {
            email
          }
        });
        setForgotPasswordEmail(email);
        setIsResettingPassword(false);
        setRequestResetEmailError(null);
        history.push("/login-feedback#pwdchanged-step1");
      } catch (err) {
        setCompleted(false);
        setIsResettingPassword(false);
        setRequestResetEmailError(err);
        history.push("/login-feedback#pwdchanged-error");
      }
    });
    return function handleFormSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);
  return {
    forgotPasswordEmail,
    formErrors: [requestResetEmailError],
    handleCancel,
    handleFormSubmit,
    hasCompleted,
    isResettingPassword
  };
};